// Libs
import { createSelector } from 'reselect'
import _reduce from 'lodash/reduce'
import _find from 'lodash/find'
import _map from 'lodash/map'

// Selectors
import selectedFeatureIndices$ from './selectedFeatureIndices'
import featuresOfSelectedField$ from './featuresOfSelectedField'

// Exports
export default createSelector(
  [selectedFeatureIndices$, featuresOfSelectedField$],
  function (selectedFeatures, features) {
    if (selectedFeatures && selectedFeatures.length) {
      const lockedFeatures = []

      const unLockedFeatures = _reduce(features, (acc, feature) => {
        const selectedFeature = _find(selectedFeatures, (featureIndex) => {
          return feature.properties.featureIndex === featureIndex
        })

        if (selectedFeature || selectedFeature === 0) {
          acc.push({
            type: feature.type,
            properties: {...feature.properties, isLocked: false},
            geometry: feature.geometry,
          })
        } else if (!selectedFeature && selectedFeature !== 0) {
          lockedFeatures.push({
            type: feature.type,
            properties: {...feature.properties, isLocked: true},
            geometry: feature.geometry,
          })
        }
        return acc
      }, [])

      return [...unLockedFeatures, ...lockedFeatures]
    }

    return _map(features, ({type, properties, geometry}) => (
      {type, properties: {...properties, isLocked: true}, geometry}
    ))
  }
)
